import Button from "components/Button";
import TenantLogo from "components/TenantLogo";
import WhiteText from "components/WhiteText";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import React from "react";
import { Pressable, StyleProp, TextStyle, View } from "react-native";

interface HeaderProps {
  programName?: string;
  showLogin?: boolean;
  textStyle?: StyleProp<TextStyle>;
}
const Header = (props: HeaderProps) => {
  const { programName, showLogin = false, textStyle } = props;
  const { data: branding } = useFetchTenantBrandingQuery();

  const LOGO_SIZE = 70;
  return (
    <View
      className="min-h-16 shadow-lg p-6"
      style={{ backgroundColor: branding?.primaryColor }}
    >
      <View>
        <View className="flex-row justify-between items-center">
          <View className="flex-row items-center gap-2">
            <Pressable onPress={() => (window.location.href = "/")}>
              <TenantLogo height={LOGO_SIZE} width={LOGO_SIZE} />
            </Pressable>
            <WhiteText style={textStyle}>{programName}</WhiteText>
          </View>
          {showLogin && (
            <Button
              appearance="outline"
              onPress={() => (window.location.pathname = "/login")}
            >
              LOGIN
            </Button>
          )}
        </View>
      </View>
    </View>
  );
};

export default Header;
